
















































































































import Vue from 'vue'
import ServerPaginationList from '@/components/ServerPaginationList.vue'

export default Vue.extend({
  name: 'News',
  components: {
    ServerPaginationList,
  },
  data: () => ({
    bottomMargin: true,
  }),
})
